// var $ = jQuery;
(function($) {

	$( document ).ready( function() {
		gs.init();
	}); 
	$(document).scroll(function() {
		sc.init();
	});  
	var gs = {
		socialShareHTML: '',
		views: ['front', 'back', 'left', 'right'],
		init: function() {
			this.initCustomSlider();
			this.addStepsIndicator();
			this.initCopyEvent();
			this.setCartSocialShareHTML();
			this.generateProductPreview();
		},
		initCustomSlider: function() {
			if ( $('.custom-slider').length > 0 ) {
				$('.custom-slider').slick( {
					infinite: true,
					dots: true
				}); 
			}
		},
		addStepsIndicator: function() {
			if ( $('.template-product').length > 0 ) {
				let param = '//';

				$(document).on('click', function(e) {
					var totalSteps = $('.hamburgerPopup a').length;
				
					if ($(e.target).hasClass('react-tabs__tab') ) {
						var currentIndex = $(e.target).index() + 1;
						
 

						if ( currentIndex == totalSteps ) {
							gs.initSocialShare(true);
						}

						$('.step-ind', e).remove();
						setTimeout( function() {
							// $('.step-ind', e).remove()
							$('.newTabNavigation').append(`<div class="step-ind"><span class="step-active">${currentIndex}</span> / <span>${totalSteps}</span></div>`)
						}, 100)
					}
				})

				$('body').on('change keyup', 'input[step]', function() {
					gs.initSocialShare();
				})

				$('body').on('click', '.option-type-color', function() {
					gs.initSocialShare();
				})
			}
		},
		getProductConfigUrl: async () => {
			var configId = await window._cpb.saveConfig(null, false);
			return window.location.origin + window.location.pathname + '?configid=' + configId;
		},
		setSocialShareHTML: function(url) {
			var fbHTML = twitterHTML = googleHTML = gmailHTML = pinterestHTML = tumblrHTML = '';
			let productTitle = $('.productTitle').text();
			let facebookUrl = `'//www.facebook.com/sharer.php?u=${url}', 'Gimmel Sports', 'width=530, height=450, left=200, top=200, fullscreen=no'`;
			let twitterUrl = `'//twitter.com/share?text=${productTitle}&url=${url}', 'Gimmel Sports', 'width=530, height=450, left=200, top=200, fullscreen=no'`;
			let googleUrl = `'//plus.google.com/share?url=${url}', 'Gimmel Sports', 'width=530, height=450, left=200, top=200, fullscreen=no'`;
			var pinterestUrl = `'//pinterest.com/pin/create/button/?url=${url}', 'Gimmel Sports', 'width=530, height=450, left=200, top=200, fullscreen=no'`;
			let tumblrUrl = `'//tumblr.com/widgets/share/tool?canonicalUrl=${url}', 'Gimmel Sports', 'width=530, height=450, left=200, top=200, fullscreen=no'`;
			let gmailUrl = `'https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&su=Gimmel%20Sports%20Product&body=Please%20Check%20this%20${url}', 'Gimmel Sports', 'width=530, height=450, left=200, top=200, fullscreen=no'`;

			
				fbHTML= `<a class="ssi-icon facebook" onclick="window.open(${facebookUrl})" target="_blank" title="Share to Facebook"><i class="fa fa-facebook"></i></a>`;
			 
			
			
			
				 gmailHTML = `<a onclick="window.open(${gmailUrl})" target="_blank" class="ssi-icon envelope" title="Share using Email"><i class="fa fa-envelope"></i></a>`;
			
			
				pinterestHTML = `<a onclick="window.open(${pinterestUrl})" target="_blank" class="ssi-icon pinterest" title="Share to Pinterest"><i class="fa fa-pinterest"></i></a>`;
			
			

			gs.socialShareHTML = `
				<div class="social-share">
					<div class="social-share-item">
						<input type="hidden" class="" id="copy-link" value="${url}">
						<span>Share this customized product: </span>
						${fbHTML}
						${twitterHTML}
						${googleHTML}
						${gmailHTML}
						${pinterestHTML}
						${tumblrHTML}
						<button 
                            type="button" 
							class="ssi-icon link share-link-btn product-builder-btn btn"
							title="Copy the Share Link"
						>
							Copy Link <i class="fa fa-link"></i>
						</button>
					</div>
				</div>
				<button id="download-image" class="product-builder-btn btn btn-download">Download Images <i class="fa fa-download"></i></button>
			`;
		},
		initSocialShare: async function(lastStep = false) {
			if ( $('.react-tabs__tab-panel--selected.cpb-product-panel:last-child').length > 0 || lastStep ) {
				$('.social-share').remove();
				$('#download-image').remove();
				var url = await gs.getProductConfigUrl();
				gs.setSocialShareHTML(url);
				gs.displaySocialShare();
			}
		},
		displaySocialShare: function() {
			if ( $('.extraTextDelivery').length > 0 ) {
				$('#product-builder .extraTextDelivery').after(gs.socialShareHTML)
			} else {
				$('#product-builder .cpb-add-to-cart-button').after(gs.socialShareHTML)
			}
		},
		initCopyEvent: async function() {
			$('body').on('click', '.share-link-btn', async function(e) {
				$(this).addClass('link-active');
				var url = '';
				var $temp = $("<input>");
                var conf
				$("body").append($temp);

				if ( $('.template-cart').length > 0 ) {
				  //url = "https://gimmelsports.com"+$(this).parents('.cart_item').find('.product-name a').attr('href');
                  url = $(this).parents('.cart_item').find('.product-name').attr('data-confId');
				} else {
					url = await gs.getProductConfigUrl();
				}
                //console.log(gs.getProductConfigUrl());
				$temp.val(url).select();
				document.execCommand("copy");
				$temp.remove();
				setTimeout(() => {
					$(this).removeClass('link-active')
				}, 3000);
			})
		},
		setCartSocialShareHTML: function() {
			if ( $('.template-cart').length > 0 ) {
				$('.cart .cart_item').each( function(i, el) {
					gs.socialShareHTML = '';
					let url = $('.product-name a', el).attr('href')
					gs.setSocialShareHTML(url);
					$('.product-name', el).append(gs.socialShareHTML);
				})
			}
		},
		generateProductPreview: function() {
			$('body').on('click', '#download-image', function() {
				var d = new Date(); 
				var name = 'preview_' + d.getTime().toString(16) + '.png';
				var link = document.createElement('a');
				link.download = name;
				window.cpbImageStorage.getCollage(1000, imageData => {
					link.href = imageData;
					link.click();
				});
			});
		},
	}
  
    var sc = {
		init: function() {
			this.initScrollstick(); 
		}, 
		
		initScrollstick: function() {
				if ( $('#product-builder').length > 0) {
					$('body').addClass('cpbuilder');
				} 
				if ( $('#product-builder').length > 0) {
					$('body').addClass('cpbuilder');
				}
				if ($(window).width() < 960) {
 
					if ($(document).scrollTop() >= 100) {
						$('.cpb-preview-container').css({ 
							'position': 'fixed',  
							'top': '0',
							'z-index': '99999999',
							'margin-bottom': '0',
							'max-height': '60%',
							'padding-top': '44%'
						});  
						$('#product-builder .cpb-preview-elements').css({
							'padding-top': '60%'
						}); 
						
						$('#product-builder .konvajs-content canvas').css({
							'max-height': '60%', 
							'width': 'auto',
							'margin': 'auto' 
						});  

						$('#product-builder .konvajs-content').css({
							'width': '100%'
						}); 
						$('#product-builder .swiper-wrapper').css({
							'background': '#fff'
						}); 
						
					}   
					else { 
						$('.cpb-preview-container').css({
							'position': 'relative',
							'top': 'auto', 
							'z-index': '1',  
							'background': 'none', 
							'margin-bottom': '100px',
							'padding-top': '100%'
						});
						$('#product-builder .cpb-preview-elements').css({
							'padding-top': '100%' 
						});   
						$('#product-builder .konvajs-content canvas').css({
							'max-height': 'none'
						}); 
						$('#product-builder .konvajs-content').css({
							'width': 'auto'
						}); 
						$('#product-builder .swiper-wrapper').css({
							'background': 'transparent'
						});     
					} 
			}
		}
	}  



})(jQuery)